import { render, staticRenderFns } from "./SurveyDetailsResults.vue?vue&type=template&id=29d2c1f2&scoped=true&"
import script from "./SurveyDetailsResults.vue?vue&type=script&setup=true&lang=js&"
export * from "./SurveyDetailsResults.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./SurveyDetailsResults.vue?vue&type=style&index=0&id=29d2c1f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d2c1f2",
  null
  
)

export default component.exports